const NAMESPACE = 'UPLOAD_FILE_TO_SD_CARD' as const;

const MODAL_KEY = `${NAMESPACE}/uploadFileToSdCardModal` as const;

const UPLOAD_STATUS = Object.freeze({
  FAILED: 'FAILED',
  UPLOADED: 'UPLOADED',
  UPLOADING: 'UPLOADING',
} as const);

export default {
  NAMESPACE,
  MODAL_KEY,
  UPLOAD_STATUS,
};
